<template>
  <i18n-t :keypath="'NotificationsComponent.' + notification.type" tag="span" class="pl-quarter" scope="global">
    <template #link>
      <button
        id="primaryEmailVerificationWebroot"
        class="inline-btn-link"
        type="button"
        @click="openPrimaryEmailVerificationDialog()"
      >
        {{ tn("VerifyEmailAddress") }}
      </button>
    </template>
  </i18n-t>
</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import { logEvent } from "@/common/logger";
import { t } from "@/i18n";
import { INotification } from "@/stores/notifications";

const componentName = "PrimaryEmailVerificationWebrootNotification";

export default defineComponent({
  name: componentName,
  props: {
    notification: {
      type: Object as PropType<INotification>,
      default: null,
    },
  },
  emits: ["custom-notification-event"],
  setup(props, context) {
    logEvent("created", componentName);

    function tn(v: string, params?: Record<string, unknown>): string {
      return t(`${componentName}.${v}`, params);
    }

    function openPrimaryEmailVerificationDialog() {
      context.emit("custom-notification-event", props.notification, "openPrimaryEmailVerification");
    }
    return {
      tn,
      openPrimaryEmailVerificationDialog,
    };
  },
});
</script>
<style lang="css" scoped>
@import "@/styles/variables.css";
</style>
